import React from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { rrss } from "../data/links";
import suitsImg from "../assets/img/suits.png";
import searchImg from "../assets/img/search.png";
import discordImg from "../assets/img/rrss/rrss-dc.png";

export default function Home() {
  return (
  <>
    <HelmetProvider>
      <Helmet>
        <title>Inicio | ERI</title>
      </Helmet>
    </HelmetProvider>
    <div id="home" className="content">
      <div className="content-wrapper">
        <div className="content-title">
          <h1 className="title">
            Más que una simple Escape Room online.
            <span className="break">Sumérgete en nuestro universo y déjate atrapar por la historia.</span>
         </h1>
        </div>
        <div className="content-main">
          <div className="content-items">
            <div className="column-item separator-right">
              <p className="title">Elige tu palo</p>
              <img className="icon" alt="Palo" src={suitsImg} />
              <p className="text">Puedes ver más información sobre cada palo e incluso hacer un test por si aún tienes dudas.</p>
              <Link className="btn btn-primary" to="/test-palos">
                Más información
              </Link>
            </div>
            <div className="column-item separator-right">
              <p className="title">Profundiza en la historia</p>
              <img className="icon" alt="Historia" src={searchImg} />
              <p className="text">
                Disfruta de la narrativa del universo ERI a través de nuestros proyectos:<br />
                - Juega a los eventos disponibles.<br />
                - Lee nuestra novela.
              </p>
              <Link className="btn btn-primary" to="/proyectos">
                Nuestros proyectos
              </Link>
            </div>
            <div className="column-item">
              <p className="title">Únete a nuestro servidor</p>
              <img className="icon" alt="Logo de Discord" src={discordImg} />
              <p className="text">Conoce gente con gustos similares en nuestro servidor Discord.</p>
              <a className="btn btn-primary" href={rrss.dc} target="_blank" rel="noopener noreferrer">Unirse al servidor</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  );
}
